var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 0.000976562C13.4332 0.000976562 0 13.4315 0 29.9997C0 46.5678 13.4319 59.9983 30 59.9983C46.5694 59.9983 60 46.5678 60 29.9997C60 13.4315 46.5694 0.000976562 30 0.000976562ZM30 8.97093C35.4819 8.97093 39.924 13.4144 39.924 18.8936C39.924 24.3742 35.4819 28.8163 30 28.8163C24.5208 28.8163 20.0786 24.3742 20.0786 18.8936C20.0786 13.4144 24.5208 8.97093 30 8.97093ZM29.9934 52.1551C24.526 52.1551 19.5186 50.1639 15.6562 46.8682C14.7154 46.0657 14.1724 44.889 14.1724 43.6542C14.1724 38.0973 18.6699 33.6498 24.2282 33.6498H35.7744C41.334 33.6498 45.8144 38.0973 45.8144 43.6542C45.8144 44.8903 45.2741 46.0644 44.3319 46.8669C40.4709 50.1639 35.4621 52.1551 29.9934 52.1551Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfile);
export default __webpack_public_path__ + "static/media/profile.1f94fe58c628de5eb2ed89d691012f7f.svg";
export { ForwardRef as ReactComponent };